import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import history from 'src/history'
// Actions
import { setFilter } from 'src/actions/filters'
// Selectors
import { routeToListing, routeToListings } from 'src/store/selectors/routes'
// Constants
import { LISTING } from 'src/constants/listings'

export default (filter, customerId) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (filter && filter.location && customerId) {
      const { location } = filter

      if (location.level === LISTING) {
        const route = routeToListing(customerId, location.payload.id)
        history.push(route)
      } else {
        dispatch(setFilter(filter))
        const route = routeToListings(
          customerId,
          location.level,
          location.name,
          filter.additionalFilters
        )
        history.push(route)
      }
    }
  }, [
    dispatch,
    filter,
    filter?.location,
    filter?.order,
    filter?.additionalFilters,
    customerId,
  ])
}
